

export default {
  name: "HappyKidsInsurerBannerSection",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    breadcrumbTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    backgroundDesktop() {
      return this.data?.BannerDesktop?.url ? this.data?.BannerDesktop?.url : 'none';
    },
    backgroundMobile() {
      return this.data?.BannerMobile?.url ? this.data?.BannerMobile?.url : 'none';
    },
    badgeDesktop() {
      return this.data?.BannerBadgeDesktop?.url ? this.data?.BannerBadgeDesktop?.url : 'none';
    },
    badgeMobile() {
      return this.data?.BannerBadgeMobile?.url ? this.data?.BannerBadgeMobile?.url : 'none';
    }
  }
}
